import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export interface RequestTrialLinkProps {
    onClick: () => void;
    label?: string;
}
export const RequestTrialLink = ({ onClick, label }: RequestTrialLinkProps) => {
    return (<div onClick={onClick} className={styles.link}>
            {label ? label : "Request a free trial."}
        </div>);
};
const styles = {
    link: css({
        display: "inline-flex",
        alignItems: "center",
        gap: space[4],
        font: text.body.bold.medium,
        color: themeTokens.color.text.link.default,
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            color: themeTokens.color.text.link.hover,
        },
    }),
};
